import { getIntlLocale } from '@/i18n/locale';
import { useI18nStore } from '@/stores/i18n-store';

export function formatCurrency(value: number): string {
  const locale = useI18nStore.getState().locale;
  return new Intl.NumberFormat(getIntlLocale(locale), {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}

